"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbsProvider = exports.BreadcrumbsContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.BreadcrumbsContext = (0, react_1.createContext)({
    items: [], addItem: () => {
    }, removeItem: () => {
    },
});
const BreadcrumbsProvider = ({ children }) => {
    const [items, setItems] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
    }, [items]);
    const addItem = (item) => {
        setItems(prevItems => [...prevItems, item]);
    };
    const removeItem = (addItem) => {
        setItems(prevItems => [...prevItems].filter(item => item.key !== addItem.key));
    };
    return ((0, jsx_runtime_1.jsx)(exports.BreadcrumbsContext.Provider, { value: {
            items,
            addItem,
            removeItem,
        }, children: children }));
};
exports.BreadcrumbsProvider = BreadcrumbsProvider;
